import React, { useEffect, useState } from "react";
import "./Topnav.css";
import { useDispatch, useSelector } from "react-redux";
import { setTopNavSelection } from "./topNavSlice";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { logoutURL, JWTToken } from "../../constant/AppConstant";
import {
  Home,
  LogOut,
  Bell,
  Calendar,
  Award,
  Menu,
  UserIcon,
  X,
  BookOpen,
  HelpCircle,
  School as SchoolIcon,
  Users as UsersIcon,
  MessageSquare,
  Briefcase,
  Presentation,
  MessageCircle,
  UserCircle,
  LayoutDashboard,
  FileText,
  BarChart2,
  ClipboardList,
  Lightbulb,
  LifeBuoy,
  CheckSquare,
  FileCheck,
  TrendingUp,
  Bookmark,
  StickyNote,
  MessageSquarePlus,
} from "lucide-react";
import { useAuth0 } from "@auth0/auth0-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { setUserIsRendered, setUserToken } from "../User/userSlice";
import { motion, AnimatePresence } from "framer-motion";
import { QAPage } from "../Student/QA/QAPage";
import CalendarView from "../student-dashboard/components/calender/CalendarView";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import BookmarksDialog from "../student-dashboard/components/bookmarks-dialog";
import NotesDialog from "../student-dashboard/components/notes-dialog";
import FacultyTopNav from "../FacultyPortal/FacultyTopNav";
import AdminSidebar from "../Admin/AdminSidebar";
import AdminTopNav from "../Admin/AdminTopNav";

const iconAnimation = {
  hover: { scale: 1.1 },
};
const Topnav = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isNotesOpen, setIsNotesOpen] = useState(false);
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useAuth0();
  const roleId = user?.["http://learnido-app/roleId"];
  const isGuestPage = location.pathname.startsWith("/guest/");
  const [discussionPath, setDiscussionPath] = useState("/discussions");
  const topNavSelection = useSelector((state) => state.topNav.topNavSelection);

  const getDiscussionsPath = (roleId) => {
    if (roleId === "2") {
      return "/school-admin/discussions"; // For School Admin
    } else if (roleId === "3") {
      return "/teacher/discussions"; // For Teacher
    } else if (roleId === "8") {
      return "/industry-expert/discussions"; // For Industry Expert
    } else {
      return "/discussions"; // For Students and default
    }
  };

  useEffect(() => {
    if (user) {
      var rid = user["http://learnido-app/roleId"];
      setDiscussionPath(getDiscussionsPath(rid));
    }
  }, [user]);

  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timerId);
  }, []);

  const navbar =
    roleId === "1"
      ? [
        {
          name: "Dashboard",
          icon: LayoutDashboard,
          path: "/admin/dashboard",
        },
        {
          name: "Courses",
          icon: Home,
          path: "/admin/courses",
        },
        {
          name: "Queries",
          icon: HelpCircle,
          path: "/admin/queries",
        },
        // {
        //   name: "Questions",
        //   icon: ClipboardList,
        //   path: "/admin/questions",
        // },
        // {
        //   name: "Assignments",
        //   icon: ClipboardList,
        //   path: "/admin/assignments",
        // },
        {
          name: "Projects",
          icon: Lightbulb,
          path: "/admin/projects",
        },
        {
          name: "LiveKit",
          icon: Presentation,
          path: "/admin/livekit",
        },
        {
          name: "Recording",
          icon: Presentation,
          path: "/admin/recording-requests",
        },
        {
          name: "My Space",
          icon: FileText,
          path: "/admin/my-space",
        },
        {
          name: "Schools",
          icon: SchoolIcon,
          path: "/admin/schools",
        },
        // {
        //   name: "Subjects",
        //   icon: BookOpen,
        //   path: "/admin/subjects",
        // },

        {
          name: "Think Space",
          icon: MessageSquare,
          path: "/school-admin/discussions",
        },
        {
          name: "Job Board",
          icon: Briefcase,
          path: "/admin/job-board",
        },
        {
          name: "Innovation Pod",
          icon: Lightbulb,
          path: "/admin/innovation-pod",
        },
        {
          name: "Student Feedback",
          icon: MessageSquarePlus,
          path: "/admin/student-feedback",
        },
      ]
      : roleId === "2"
        ? [
          {
            name: "Courses",
            icon: Home,
            path: "/school-admin/courses",
          },
          {
            name: "Users",
            icon: UsersIcon,
            path: "/school-admin/users",
          },
          {
            name: "Classrooms",
            icon: Presentation,
            path: "/school-admin/classrooms",
          },
          {
            name: "Queries",
            icon: HelpCircle,
            path: "/school-admin/queries",
          },

          {
            name: "Think Space",
            icon: MessageSquare,
            path: getDiscussionsPath(),
          },
        ]
        : roleId === "3"
          ? [
            {
              name: "Classroom",
              icon: Presentation,
              path: "/teacher/classroom",
            },
            {
              name: "Queries",
              icon: HelpCircle,
              path: "/teacher/queries",
            },
            {
              name: "My Space",
              icon: LayoutDashboard,
              path: "/teacher/my-space",
            },

            {
              name: "Think Space",
              icon: MessageSquare,
              path: getDiscussionsPath(),
            },
            // {
            //   name: "Submissions",
            //   icon: FileCheck,
            //   path: "/teacher/submissions",
            // },
            {
              name: "Innovation Pod",
              icon: Lightbulb,
              path: "/teacher/innovation-pod",
            },
          ]
          : roleId === "6"
            ? [
              { name: "My Space", icon: FileText, path: "/instructor/my-space" },
              { name: "Queries", icon: HelpCircle, path: "/instructor/queries" },
              {
                name: "Think Space",
                icon: MessageSquare,
                path: "/instructor/discussions",
              },
              {
                name: "LiveKit Sessions",
                icon: Presentation,
                path: "/instructor/livekit",
              },
              {
                name: "Recording",
                icon: Presentation,
                path: "/instructor/recording-requests",
              },
              {
                name: "Project Groups",
                icon: ClipboardList,
                path: "/instructor/submissions",
              },
              {
                name: "Submissions",
                icon: (
                  <FileCheck
                    className="nav-icon"
                    size={20}
                    strokeWidth={2}
                    color="#ffffff"
                  />
                ),
                path: "/teacher/submissions",
              },
              {
                name: "Notifications",
                icon: Bell,
                path: "/instructor/notifications",
              },
              {
                name: "Innovation Pod",
                icon: Lightbulb,
                path: "/instructor/innovation-pod",
              },
              {
                name: "Student Feedback",
                icon: MessageSquarePlus,
                path: "/instructor/student-feedback",
              },
            ]
            : roleId === "5"
              ? [
                // {
                //   name: "Course Creator",
                //   icon: LayoutDashboard,
                //   path: "/admin/content-creator",
                // },
                {
                  name: "Courses",
                  icon: Home,
                  path: "/admin/courses",
                },
                // {
                //   name: "Questions",
                //   icon: ClipboardList,
                //   path: "/admin/questions",
                // },
                // {
                //   name: "Assignments",
                //   icon: ClipboardList,
                //   path: "/admin/assignments",
                // },
                {
                  name: "Projects",
                  icon: Lightbulb,
                  path: "/admin/projects",
                },
                {
                  name: "My Space",
                  icon: FileText,
                  path: "/admin/my-space",
                },
                {
                  name: "Schools",
                  icon: SchoolIcon,
                  path: "/admin/schools",
                },
                // {
                //   name: "Users",
                //   icon: UsersIcon,
                //   path: "/admin/users",
                // },
                // {
                //   name: "Subjects",
                //   icon: BookOpen,
                //   path: "/admin/subjects",
                // },
                {
                  name: "LiveKit",
                  icon: Presentation,
                  path: "/admin/livekit",
                },
                {
                  name: "Recordings",
                  icon: Presentation,
                  path: "/admin/recordings",
                },
                {
                  name: "Innovation Pod",
                  icon: Lightbulb,
                  path: "/admin/innovation-pod",
                },
                {
                  name: "Student Feedback",
                  icon: MessageSquarePlus,
                  path: "/admin/student-feedback",
                },
              ]
              : roleId === "7"
                ? [{ name: "Analytics", icon: BarChart2, path: "/faculty/analytics" }]
                : roleId === "8"
                  ? [
                    {
                      name: "Dashboard",
                      icon: LayoutDashboard,
                      path: "/expert/dashboard",
                    },
                    {
                      name: "Think Space",
                      icon: MessageSquare,
                      path: "/industry-expert/discussions",
                    },
                  ]
                  : [
                    // Student users: Home removed, logo acts as home
                  ];

  const handleSetNavBar = (item) => {
    dispatch(setTopNavSelection(item.name));
    navigate(item.path);
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem(JWTToken);
    localStorage.removeItem("IdToken");
    dispatch(setUserIsRendered(false));
    dispatch(setUserToken(null));
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  useEffect(() => {
    // Update the topNavSelection when the route changes
    const path = location.pathname;
    console.log("path", path);
    if (path === "/") {
      dispatch(setTopNavSelection("Home"));
    } else {
      const currentRoute = navbar
        .filter((item) => item.path !== "/")
        .find((item) => path.includes(item.path));
      console.log("currentRoute", currentRoute);
      if (currentRoute) {
        dispatch(setTopNavSelection(currentRoute.name));
      } else {
        dispatch(setTopNavSelection(null));
      }
    }
  }, [location.pathname, navbar]);

  const menuAnimation = {
    hidden: { opacity: 0, y: -20 },
    show: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  };

  const textAnimation = {
    collapsed: {
      width: 0,
      opacity: 0,
      marginLeft: 0,
      transition: { duration: 0.2 },
    },
    expanded: {
      width: "auto",
      opacity: 1,
      marginLeft: 8,
      transition: { duration: 0.2 },
    },
  };

  const isAdmin = roleId === "1" || roleId === "5" || roleId === "6" || roleId === "3";
  const isOriginalAdmin = roleId === "5" || roleId === "6" || roleId === "3";

  // Ensure no sidebar styling leaks into guest routes
  useEffect(() => {
    if (isGuestPage) {
      document.body.classList.remove("has-left-sidebar");
    }
  }, [isGuestPage]);

  useEffect(() => {
    if (isOriginalAdmin && !isGuestPage) {
      document.body.classList.add("has-left-sidebar");
    } else {
      document.body.classList.remove("has-left-sidebar");
    }
    return () => {
      document.body.classList.remove("has-left-sidebar");
      document.body.classList.remove("has-admin-sidebar");
    };
  }, [isAdmin, isGuestPage]);

  useEffect(() => {
    if (roleId === "1" && !isGuestPage) {
      document.body.classList.add("has-admin-sidebar");
    } else {
      document.body.classList.remove("has-admin-sidebar");
    }
  }, [roleId, isGuestPage]);

  if (isGuestPage) {
    return null;
  }

  if (roleId === "1") {
    return (
      <>
        <AdminTopNav user={user} handleLogout={handleLogout} />
        <AdminSidebar user={user} />
      </>
    );
  }

  if (isAdmin) {
    return (
      <>
        {/* Mobile toggle button (admin, course creator, instructor only) */}
        {!mobileMenuOpen && (
          <motion.button
            className="mobile-menu-button fixed left-3 top-3 z-[70] md:hidden bg-black/60 text-white rounded-full p-2 shadow-lg"
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open menu"
            aria-expanded={false}
            aria-controls="left-sidebar"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <Menu size={20} />
          </motion.button>
        )}

        {/* Backdrop for mobile */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              className="sidebar-backdrop md:hidden"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setMobileMenuOpen(false)}
            />
          )}
        </AnimatePresence>

        {/* Left Sidebar Drawer (admin, course creator, instructor only) */}
        <motion.aside
          id="left-sidebar"
          className={`left-sidebar ${mobileMenuOpen ? "open" : ""}`}
          initial={false}
          animate={mobileMenuOpen ? { x: 0 } : {}}
        >
          <div className="topnav-content flex-col items-stretch">
            <motion.div
              className="logo-container px-2 py-4 flex items-center justify-between"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3 }}
            >
              <img src={"/Vyudi-Logo.png"} alt="Learnido Logo" className="logo bg-white p-1 rounded-md" />
              {/* Internal close button for mobile */}
              <button
                className="md:hidden bg-black/50 text-white rounded-full p-2 shadow"
                onClick={() => setMobileMenuOpen(false)}
                aria-label="Close menu"
              >
                <X size={18} />
              </button>
            </motion.div>

            <nav className="sidebar-menu">
              <AnimatePresence>
                {navbar.map((item, index) => (
                  <motion.button
                    key={index}
                    className={`nav-item ${topNavSelection === item.name ? "active" : ""
                      }`}
                    onClick={() => handleSetNavBar(item)}
                    initial="hidden"
                    animate="show"
                    exit="exit"
                    variants={menuAnimation}
                    transition={{ delay: index * 0.05 }}
                    whileHover={{ x: 2 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <span className="flex items-center">
                      {React.isValidElement(item.icon)
                        ? React.cloneElement(item.icon, {
                          className: "nav-icon",
                          size: 20,
                          strokeWidth: 2,
                        })
                        : React.createElement(item.icon, {
                          className: "nav-icon",
                          alt: item.name,
                          size: 20,
                          strokeWidth: 2,
                        })}
                      <motion.span
                        initial="collapsed"
                        animate={"expanded"}
                        variants={textAnimation}
                        className="nav-text whitespace-nowrap"
                      >
                        {item.name}
                      </motion.span>
                    </span>
                  </motion.button>
                ))}
              </AnimatePresence>
            </nav>

            <div className="mt-auto px-2 pb-4">
              <UserMenu user={user} handleLogout={handleLogout} />
            </div>
          </div>
        </motion.aside>
      </>
    );
  }

  if (roleId === "7") {
    return <FacultyTopNav user={user} handleLogout={handleLogout} />;
  }

  if (roleId === "8") {
    return (
      <nav className="top expert-nav-special">
        <div className="top-l">
          <div className="logo">
            <img src="/Vyudi-Logo.png" alt="Vyudi" />
          </div>
          <div className="top-div"></div>
          <div className="top-tag">Expert Portal</div>
        </div>
        <div className="top-r">
          <div className="top-user" onClick={() => navigate("/profile")}>
            <div className="top-av">{user?.nickname?.substring(0, 2).toUpperCase() || 'EX'}</div>
            <div className="top-info">
              <div className="top-nm">{user?.name || user?.email}</div>
              <div className="top-rl">Industry Expert</div>
            </div>
          </div>
          <button onClick={handleLogout} className="topbar-action-btn ml-2">
            <LogOut size={16} className="mr-1" />
            <span>Logout</span>
          </button>
        </div>
      </nav>
    );
  }

  // Non-admin users: fallback to original top header
  return (
    <header className={`topnav-header ${roleId === "8" ? "expert-nav" : ""}`}>
      <div className="topnav-content">
        <motion.div
          className={`logo-container ${(!roleId || roleId === "4") ? "cursor-pointer" : ""}`}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
          onClick={() => {
            if (!roleId || roleId === "4") {
              navigate("/");
              dispatch(setTopNavSelection("Home"));
            }
          }}
        >
          <img src={"/Vyudi-Logo.png"} alt="Learnido Logo" className="logo bg-white p-1 rounded-md" />
        </motion.div>

        <nav className="desktop-menu">
          <AnimatePresence>
            {navbar.map((item, index) => (
              <motion.button
                key={index}
                className={`nav-item ${topNavSelection === item.name ? "active" : ""
                  }`}
                onClick={() => handleSetNavBar(item)}
                initial="hidden"
                animate="show"
                exit="exit"
                variants={menuAnimation}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                <span className="flex items-center">
                  {React.isValidElement(item.icon)
                    ? React.cloneElement(item.icon, {
                      className: "nav-icon",
                      size: 20,
                      strokeWidth: 2,
                    })
                    : React.createElement(item.icon, {
                      className: "nav-icon",
                      alt: item.name,
                      size: 20,
                      strokeWidth: 2,
                    })}
                  <motion.span
                    initial="collapsed"
                    animate={
                      topNavSelection === item.name ? "expanded" : "collapsed"
                    }
                    whileHover="expanded"
                    variants={textAnimation}
                    className="nav-text whitespace-nowrap"
                  >
                    {item.name}
                  </motion.span>
                </span>
              </motion.button>
            ))}
          </AnimatePresence>
        </nav>

        {roleId !== "1" &&
          roleId !== "2" &&
          roleId !== "5" &&
          roleId !== "6" &&
          user && (
            <motion.div
              className="user-actions"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              {/* Raise a Question Button */}
              <motion.button
                className="topbar-action-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate("/qa")}
              >
                <HelpCircle size={16} className="mr-2" />
                <span className="btn-text">Raise a Question</span>
              </motion.button>

              {/* My Profile Dropdown */}
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <motion.button
                    className="topbar-action-btn profile"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <div className="top-av-mini mr-2">
                      {user?.nickname?.substring(0, 2).toUpperCase() || "TU"}
                    </div>
                    <span className="btn-text">My Profile</span>
                  </motion.button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-64 bg-white p-2">
                  <div className="px-4 py-3 flex flex-col space-y-1 border-b border-gray-100 mb-1">
                    <p className="text-sm font-semibold text-gray-900 leading-none">{user?.name}</p>
                    <p className="text-xs text-gray-500 leading-none truncate">{user?.email}</p>
                  </div>
                  <DropdownMenuItem onClick={() => navigate("/profile")} className="cursor-pointer">
                    <UserIcon size={16} className="mr-2" />
                    <span>Profile</span>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={handleLogout} className="text-red-600 focus:text-red-700 cursor-pointer">
                    <LogOut size={16} className="mr-2" />
                    <span>Logout</span>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>

              {/* Time Clock - Right side of My Profile */}
              <div className="digital-clock text-sm ml-3 text-black flex items-center">
                {currentTime.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>

              {roleId !== "4" && (
                <>
                  <motion.button
                    className="icon-button"
                    aria-label="Support"
                    whileHover="hover"
                    variants={iconAnimation}
                    onClick={() => navigate("/qa")}
                  >
                    <HelpCircle size={18} />
                  </motion.button>
                  <BookmarksDialog
                    customTrigger={
                      <motion.button
                        className="icon-button"
                        aria-label="Bookmarks"
                        whileHover="hover"
                        variants={iconAnimation}
                      >
                        <Bookmark size={18} />
                      </motion.button>
                    }
                  />
                  <motion.button
                    className="icon-button"
                    aria-label="Notes"
                    whileHover="hover"
                    variants={iconAnimation}
                    onClick={() => setIsNotesOpen(true)}
                  >
                    <StickyNote size={18} />
                  </motion.button>
                  <NotesDialog
                    externalOpen={isNotesOpen}
                    onExternalOpenChange={setIsNotesOpen}
                    hideTriggerButton={true}
                  />
                  <Popover open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>
                    <PopoverTrigger asChild>
                      <motion.button
                        className="icon-button"
                        aria-label="Calendar"
                        whileHover="hover"
                        variants={iconAnimation}
                      >
                        <Calendar size={18} />
                      </motion.button>
                    </PopoverTrigger>
                    <PopoverContent
                      className="w-auto p-0 bg-transparent border-none shadow-none calendar-popover-content"
                      align="end"
                      sideOffset={8}
                    >
                      <CalendarView />
                    </PopoverContent>
                  </Popover>
                </>
              )}
              {roleId !== "4" && <UserMenu user={user} handleLogout={handleLogout} />}
            </motion.div>
          )}

        {(roleId === "1" ||
          roleId === "2" ||
          roleId === "5" ||
          roleId === "6") &&
          user && (
            <motion.div
              className="user-actions"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <UserMenu user={user} handleLogout={handleLogout} />
            </motion.div>
          )}

        <motion.button
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-menu"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </motion.button>
      </div>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.nav
            className="mobile-menu"
            id="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
          >
            {navbar.map((item, index) => (
              <motion.button
                key={index}
                className={`nav-item ${topNavSelection === item.name ? "active" : ""
                  }`}
                onClick={() => handleSetNavBar(item)}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <span>
                  {React.createElement(item.icon, {
                    className: "nav-icon",
                    alt: item.name,
                  })}
                  <span>{item.name}</span>
                </span>
              </motion.button>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>
    </header >
  );
};

const UserMenu = ({ user, handleLogout }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <motion.div whileHover="hover" variants={iconAnimation}>
        <Avatar className="w-7 h-7 cursor-pointer">
          <AvatarImage src={user.picture} alt={user.name} />
          <AvatarFallback>{user.name?.[0]}</AvatarFallback>
        </Avatar>
      </motion.div>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-56">
      <DropdownMenuLabel className="font-normal">
        <div className="flex flex-col space-y-1">
          <p className="text-sm font-medium leading-none">{user.name}</p>
          <p className="text-xs leading-none text-muted-foreground">
            {user.email}
          </p>
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <Link to="/profile" className="flex items-center">
          <UserIcon size={16} className="mr-2" />
          <span>Profile</span>
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem onClick={handleLogout} className="text-red-600">
        <LogOut size={16} className="mr-2" />
        <span>Log out</span>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
export default Topnav;
